module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("SPIRIT OF "), _c('span', [_vm._v("METAL")]), _c('sup', [_vm._v("alpha")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "language-switcher"
    },
    on: {
      "click": _vm.switchLanguage
    }
  }, [_c('span', [_vm._v("•")]), _vm._v(" " + _vm._s(this.$i18n.locale) + " "), _c('span', [_vm._v("•")])]), _vm._v(" "), (_vm.menuIsHidden) ? _c('img', {
    attrs: {
      "id": "burger",
      "src": require("../../assets/img/png/burger.png"),
      "alt": "Ouvrir le menu"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }) : _c('img', {
    attrs: {
      "id": "cross",
      "src": require("../../assets/img/png/cross.png"),
      "alt": "Fermer le menu"
    },
    on: {
      "click": _vm.toggleMenu
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507ef373"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Header.vue
// module id = 260
// module chunks = 0